export default __webpack_public_path__ + "static/media/MBPJeans.3326b5d8.jpg";